import React from 'react';
import PropTypes from 'prop-types';
import { Typography, Link, CardTitle } from '@one-thd/sui-atomic-components';

const ListHeader = ({
  name, url, itemCount, hideSubHeader = false, disableLink = false, viewMode = 'grid'
}) => (
  <CardTitle
    header={(
      viewMode === 'thumbnails' ? (
        <Typography lineClamp="1" variant="h3" weight="bold">
          {disableLink ? name : <a href={url}>{name}</a>}
        </Typography>
      ) : (
        <div className="sui-flex sui-items-baseline sui-gap-2">
          <Typography variant="body-base" weight="bold" component="span">
            <span className="sui-text-nowrap">List:</span>
          </Typography>
          <Typography lineClamp="2" decoration={disableLink ? null : 'underline'} component="h3" height="normal">
            {!disableLink ? (
              <Link
                href={url}
                color="primary"
                className="sui-text-base sui-text-primary sui-capitalize sui-break-all"
              >
                {name}
              </Link>
            ) : (
              <span className="sui-text-base sui-text-primary sui-capitalize sui-break-all">
                {name}
              </span>
            )}
          </Typography>
        </div>
      )
    )}
    subheader={!hideSubHeader ? (
      <span className={viewMode === 'thumbnails' ? 'sui-flex sui-gap-2' : 'sui-hidden @sm:sui-flex sui-gap-2'}>
        <Typography variant="body-base" weight="bold" component="span">
          <span className="sui-text-nowrap">Total Items:</span>
        </Typography>
        <Typography variant="body-base" component="span">{itemCount}</Typography>
      </span>
    ) : null}
  />
);

ListHeader.propTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string,
  itemCount: PropTypes.number.isRequired,
  hideSubHeader: PropTypes.bool,
  disableLink: PropTypes.bool,
  viewMode: PropTypes.string
};

ListHeader.defaultProps = {
  url: null,
  hideSubHeader: false,
  disableLink: false,
  viewMode: 'grid'
};

export default ListHeader;